module.exports = __webpack_public_path__ + "fonts/nucleo-icons.2569aaea.woff";